import { render, staticRenderFns } from "./UtilButton.vue?vue&type=template&id=55288f1c"
import script from "./UtilButton.vue?vue&type=script&lang=js"
export * from "./UtilButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports